var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStartShift = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 42,
  height: 42,
  viewBox: "0 0 42 42",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "8royd2hpda",
  x1: "50%",
  x2: "50%",
  y1: "1.421%",
  y2: "123.039%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#016DFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#1CA3FF"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "url(#8royd2hpda)",
  transform: "translate(-288 -337)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M288.997 113c-11.59 0-20.997 9.412-20.997 21 0 11.59 9.407 21 20.997 21S310 145.59 310 134c0-11.588-9.413-21-21.003-21zm-4.958 14.5c.093-.003.185.016.268.057l12.886 6.444c.188.095.307.287.307.498 0 .21-.119.404-.307.498l-12.886 6.444c-.174.087-.38.077-.544-.025-.165-.103-.264-.284-.263-.478v-12.882c.001-.3.24-.546.54-.556z",
  transform: "translate(20 224)"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStartShift);
export default ForwardRef;